<template>
  <v-row>
    <v-col cols="12">
      <v-text-field
        v-model="microsoftEmail"
        dense
        outlined
        :label="microsoftEmail ? 'E-mail Microsoft Conectado' : 'Seu endereço de e-mail aparecerá aqui após o cadastro'"
        readonly
        disabled
      />
    </v-col>

    <v-col
      cols="12"
      class="d-flex justify-end"
    >
      <microsoft-login-btn
        color="primary"
        :label="microsoftEmail ? 'Trocar conta Microsoft' : 'Conectar conta Microsoft'"
      />
    </v-col>
  </v-row>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import MicrosoftLoginBtn from '@/components/auth/MicrosoftLoginBtn.vue'

export default {
  components: {
    MicrosoftLoginBtn,
  },

  props: {
    canalData: {
      type: Object,
      default: null,
    },
  },

  setup(props) {
    const microsoftEmail = ref(null)

    watch(
      () => props.canalData,
      v => {
        microsoftEmail.value = v?.email || null
      },
      { immediate: true },
    )

    return {
      microsoftEmail,
    }
  },
}
</script>
